export default __webpack_public_path__ + "static/media/image42.e72bada0.png";